import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

import StoreLogo from '@/assets/images/store.svg'
import { Pin } from '@/components/Icons'
import { useAppSelector } from '@/utils/useAppSelector'

import styles from './Footer.module.scss'

const Footer = () => {
  const t = useTranslations()
  const countryCode = useAppSelector((state) => state.config.market?.countryCode.toLowerCase())
  const countries = useTranslations('Countries')
  const countryName = countryCode ? countries(countryCode) : ''
  return (
    <div className={styles.Footer}>
      <Link href="/" passHref>
        <a className={styles.LogoContainer} aria-label={t('sitename')}>
          <div className={styles.Logo}>
            <Image src={StoreLogo} alt={t('sitename')} layout="fill" objectFit="contain" quality={100} />
          </div>
        </a>
      </Link>
      <div className={styles.Country}>
        <Pin height={22} width={22} />
        <p>{countryName}</p>
      </div>
    </div>
  )
}

export default Footer
